<div class="container account-settings">
  <h2 i18n="@@accountSettingsTitle">Account Settings</h2>

  <div class="card">

    <form [formGroup]="accountForm" style="width: 300px;">

    </form>

    <h3 i18n="@@accountDetailsTitle">Account Details</h3>

    <div *ngIf="!editMode">

      <div class="details">
        <app-input-display-grid [values]="itemRows" [columnLength]="2">
        </app-input-display-grid>
      </div>

      <button
        pButton
        label="Edit Account Details"
        i18n-label="@@editAccountButton"
        icon="ri-pencil-fill"
        (click)="editAccount()"
        class="p-button-text">
      </button>
    </div>

    <div *ngIf="editMode">
      <form [formGroup]="accountForm" (ngSubmit)="saveAccount()">
          <div class="form-group">
            <app-input-select
              label="Coordinates"
              i18n-label="@@coordinatesLabel"
              [options]="coordinates"
              formControlName="selectedCoordinates">
            </app-input-select>
          </div>

          <div class="form-group">
            <app-input-select
              label="Language"
              i18n-label="@@accountSettings.fields.language"
              [options]="languages"
              formControlName="selectedLanguage">
            </app-input-select>
          </div>
        <div class="form-row">
          <div class="form-column">
            <app-input
              label="First Name"
              i18n-label="@@firstNameLabel"
              formControlName="firstName"
              [errorMessage]="f['firstName'].errors"
              [touched]="f['firstName'].touched"
              [required]="true">
            </app-input>

            <app-input
              label="Unit"
              i18n-label="@@unitLabel"
              formControlName="unit">
            </app-input>

            <app-input
              label="Freq/Call Sign"
              i18n-label="@@callSignLabel"
              formControlName="callSign">
            </app-input>
          </div>

          <div class="form-column">
            <app-input
              label="Last Name"
              i18n-label="@@lastNameLabel"
              formControlName="lastName"
              [errorMessage]="f['lastName'].errors"
              [touched]="f['lastName'].touched"
              [required]="true">
            </app-input>

            <app-input
              label="Phone Number"
              i18n-label="@@phoneLabel"
              formControlName="phone"
              [errorMessage]="f['phone'].errors"
              [touched]="f['phone'].touched"
              [required]="true">
            </app-input>
          </div>
        </div>

        <div class="form-actions">
          <button
            pButton
            type="button"
            label="Cancel"
            i18n-label="@@cancelButton"
            (click)="cancelEdit()"
            class="p-button-text">
          </button>

          <button
            pButton
            type="submit"
            label="Save"
            i18n-label="@@saveButton">
          </button>
        </div>
      </form>
    </div>

  </div>
</div>